"use client";
import { useState } from "react";
import Link from "next/link";
import pages from "@/data/cocon.json";
export default function Realizations() {
  const [sector, setSector] = useState("");
  const [type, setType] = useState("");
  return (
    <>
      <div className="cro-fields">
        <label>
          Secteur
          <select value={sector} onChange={(e) => setSector(e.target.value)}>
            <option value="">Tous les secteurs</option>
            {pages
              .filter((p) => p.kind === "sector")
              .map((p) => (
                <option key={p.id}>{p.name}</option>
              ))}
          </select>
        </label>
        <label>
          Type de projet
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="">Tous les projets</option>
            {["Neuf", "Remise à neuf", "Amélioration"].map((t) => (
              <option key={t}>{t}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="cro-notice" role="status">
        Aucun cas publié{sector ? ` pour le secteur ${sector}` : ""}
        {type ? ` (${type})` : ""}. Les réalisations attendent la validation de
        SECMHY.
      </div>
      <Link className="cro-text-link" href="/realisations/apercu">
        Consulter la structure d’une fiche de réalisation →
      </Link>
    </>
  );
}
